module.exports = __webpack_public_path__ + "static/media/chess-3303829_960_720.01073395.jpg";